export default __webpack_public_path__ + "static/bq-062ca4790d0d0e19d57d460a19a06100.svg";